export const SITES_LIST_PANEL_ID = 'sites-list-panel';

/**
 * Brings a site card to the top of the sites list panel. Scrolls only the panel,
 * so the page itself stays where it is.
 */
export const scrollToSiteCard = (siteCode?: string | number | null): void => {
  if (siteCode === undefined || siteCode === null || siteCode === '') return;

  const container = document.getElementById(SITES_LIST_PANEL_ID);
  const card = container?.querySelector<HTMLElement>(`[data-site-code="${siteCode}"]`);
  if (!container || !card) return;

  const offset = card.getBoundingClientRect().top - container.getBoundingClientRect().top;
  const top = Math.max(0, container.scrollTop + offset);

  if (typeof container.scrollTo === 'function') {
    container.scrollTo({ top, behavior: 'smooth' });
  } else {
    container.scrollTop = top;
  }
};
